import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=0944166a&scoped=true&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=0944166a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944166a",
  null
  
)

export default component.exports